module.exports = __webpack_public_path__ + "img/wallet.13f85908.svg";